"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// prettier-ignore
exports.default = {
    "award": 486,
    "concessional": 456,
    "directedTerminationPaymentTaxable": 465,
    "employerVoluntary": 456,
    "salarySacrifice": 4566,
    "superGuarantee": 12,
    "assessableForeignFund": 159,
    "cgtSmallBusiness15YearExempt": 456,
    "cgtSmallBusinessRetirementExempt": 756,
    "coContribution": 456,
    "directedTerminationPaymentTaxFree": 456,
    "firstHomeSuperSaverSchemeRecontribution": 98756,
    "firstHomeSaverAccount": 576,
    "homeDownsize": 432432,
    "insuranceProceeds": 186,
    "lowIncomeSuper": 456465,
    "nonAssessableForeignFund": 18,
    "nonConcessional": 418,
    "otherFamilyAndFriend": 765456,
    "personalInjury": 5674,
    "spouseAndChild": 486
};
